import React from "react";
import { measurementParts } from "../../utils/invoiceManagerSlip";

const MeasureCard = ({ title, accent, measurement, meta }) => {
  const parts = measurementParts(measurement);
  return (
    <div
      className={`rounded-xl border bg-white px-3.5 py-3 min-w-0 ${accent}`}
    >
      <p className="text-[10px] font-bold uppercase tracking-wide text-stone-500 mb-2">
        {title}
      </p>
      <p className="text-base font-semibold text-stone-900 tabular-nums leading-tight">
        {parts.dims || "Dims not recorded"}
      </p>
      <p className="text-lg font-bold text-stone-900 tabular-nums mt-1">
        {parts.weight || "—"}
      </p>
      {meta ? (
        <p className="text-xs font-medium text-stone-500 mt-2 break-words">
          {meta}
        </p>
      ) : null}
    </div>
  );
};

/**
 * Customer-given vs hub/charged measurements as two comparison cards.
 */
const MeasurementCompare = ({
  customerInput,
  hubMeasurement,
  weightBandName,
  dimensionName,
  previousMeasurement,
  changeSummary,
}) => {
  const customer = measurementParts(customerInput);
  const hub = measurementParts(hubMeasurement);
  const previous = measurementParts(previousMeasurement);
  const hubMeta = [weightBandName, dimensionName].filter(Boolean).join(" · ");

  if (
    !customer.dims &&
    !customer.weight &&
    !hub.dims &&
    !hub.weight &&
    !weightBandName &&
    !dimensionName &&
    !changeSummary
  ) {
    return null;
  }

  return (
    <div className="space-y-2 min-w-0">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
        <MeasureCard
          title="Customer given"
          accent="border-stone-200"
          measurement={customerInput}
        />
        <MeasureCard
          title="Hub / charged"
          accent="border-orange-200 bg-orange-50/40"
          measurement={hubMeasurement}
          meta={hubMeta}
        />
      </div>
      {previous.dims || previous.weight ? (
        <p className="text-xs text-stone-600">
          <span className="font-semibold">Previous version:</span>{" "}
          {[previous.dims, previous.weight].filter(Boolean).join(" · ")}
        </p>
      ) : null}
      {changeSummary ? (
        <p className="text-xs font-semibold text-amber-900 bg-amber-50 border border-amber-100 rounded-lg px-2.5 py-1.5">
          {changeSummary}
        </p>
      ) : null}
    </div>
  );
};

export default MeasurementCompare;
